module.exports = __webpack_public_path__ + "static/media/standard_passport_photo.86c115cf.JPG";